"use client";

import Navigation from "./navigation";
import type { Category } from "@/types";

type Props = {
	initialNavCategories?: Category[];
};

export default function ClientNavigation({ initialNavCategories = [] }: Props) {
	return <Navigation initialNavCategories={initialNavCategories} />;
}

